export default {
  // BASE_URL: "https://form-server-1.12n4qr898lvv0.eu-west-2.cs.amazonlightsail.com",
  BASE_URL:
    window.location.href.indexOf("localhost") >= 0
      ? "http://localhost:8080"
      : "https://form-server-1.12n4qr898lvv0.eu-west-2.cs.amazonlightsail.com",
  S3_URL: "https://s3.eu-west-2.amazonaws.com/assets.formscore.today/",
};
